import { useInvalidateAllocations } from '@features/allocation';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { allocationTagQueries } from '../queries';
import { allocationTagService } from '../services/allocationTagService';
import type { AllocationTagBody } from '../types/AllocationTag';

/** Sem `id` cria; com `id` edita. Nome e cor aparecem nas telas de alocação, que recarregam. */
export function useSaveAllocationTag() {
  const queryClient = useQueryClient();
  const invalidateAllocations = useInvalidateAllocations();

  return useMutation({
    mutationFn: ({ id, body }: { id?: number; body: AllocationTagBody }) =>
      id === undefined ? allocationTagService.create(body) : allocationTagService.update(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: allocationTagQueries.lists() });
      invalidateAllocations();
    },
  });
}
